(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open-diary"] && !Shopify.designMode) return;
  try {
    
(()=>{const r=document.querySelector('[data-open-diary]');if(!r||r.dataset.ready)return;r.dataset.ready='1';const u=r.dataset.url,k=r.dataset.key,h={apikey:k,Authorization:'Bearer '+k,'Content-Type':'application/json'},d=r.querySelector('[data-diary-date]'),t=r.querySelector('[data-diary-text]'),s=r.querySelector('[data-status]'),f=r.querySelector('[data-feed]'),q=r.querySelector('[data-dialog]'),n=r.querySelector('[data-nickname]'),ds=r.querySelector('[data-dialog-status]');const esc=x=>String(x??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));const nice=x=>new Date(x+'T00:00:00').toLocaleDateString(undefined,{day:'numeric',month:'long',year:'numeric'});const msg=(e,x)=>{e.textContent=x;setTimeout(()=>e.textContent='',2500)};d.value=new Date().toISOString().slice(0,10);r.querySelector('[data-save]').onclick=()=>{if(!t.value.trim())return msg(s,'Write something first.');const c=document.createElement('canvas'),x=c.getContext('2d'),lines=t.value.trim().split('\\n'),w=1400,p=100;c.width=w;c.height=Math.max(900,p*2+180+lines.length*42);x.fillStyle='#fff';x.fillRect(0,0,w,c.height);x.fillStyle='#222';x.font='italic 28px Georgia';x.fillText(nice(d.value),p,110);x.font='italic 38px Georgia';x.fillText('Dear diary...',p,180);x.font='22px Georgia';lines.forEach((v,i)=>x.fillText(v.slice(0,95),p,250+i*42));const a=document.createElement('a');a.download='my-diary-page.png';a.href=c.toDataURL('image/png');a.click();msg(s,'Saved as an image.');};r.querySelector('[data-publish]').onclick=()=>{if(!t.value.trim())return msg(s,'Write something first.');q.showModal();n.focus()};r.querySelector('[data-confirm]').onclick=async()=>{const v=n.value.trim();if(!v)return msg(ds,'Choose a nickname first.');r.querySelector('[data-confirm]').disabled=true;ds.textContent='Publishing…';try{const z=await fetch(u+'/rest/v1/diary_entries',{method:'POST',headers:{...h,Prefer:'return=minimal'},body:JSON.stringify({nickname:v.slice(0,40),entry_date:d.value,content:t.value.trim(),is_published:true})});if(!z.ok)throw 0;t.value='';n.value='';q.close();msg(s,'Your page has been shared.');await load()}catch(e){ds.textContent='We couldn’t publish that page right now.'}r.querySelector('[data-confirm]').disabled=false};async function reply(id,b){const a=b.closest('[data-entry]'),nn=a.querySelector('[data-reply-name]').value.trim(),cc=a.querySelector('[data-reply-text]').value.trim();if(!nn||!cc)return;b.disabled=true;try{const z=await fetch(u+'/rest/v1/diary_replies',{method:'POST',headers:{...h,Prefer:'return=minimal'},body:JSON.stringify({entry_id:id,nickname:nn.slice(0,40),content:cc.slice(0,3000)})});if(!z.ok)throw 0;await load()}finally{b.disabled=false}}async function load(){if(!u||!k)return f.innerHTML='<div class="mwm-diary__empty">The diary is ready. Add the connection settings in the theme editor to enable sharing.</div>';try{const z=await fetch(u+'/rest/v1/diary_entries?select=id,nickname,entry_date,content,diary_replies(id,nickname,content,created_at)&is_published=eq.true&order=created_at.desc&limit=30',{headers:h});if(!z.ok)throw 0;const a=await z.json();if(!a.length)return f.innerHTML='<div class="mwm-diary__empty">The diary is waiting for its first page.</div>';f.innerHTML=a.map(x=>'<article class="mwm-diary__entry" data-entry data-id="'+esc(x.id)+'"><div class="mwm-diary__entry-date">'+nice(x.entry_date)+'</div><div class="mwm-diary__entry-text">'+esc(x.content)+'</div><div class="mwm-diary__by">— '+esc(x.nickname)+'</div><div class="mwm-diary__reply"><div class="mwm-diary__reply-row"><input data-reply-name maxlength="40" placeholder="Your nickname"><button type="button" data-reply-button>Reply</button></div><textarea data-reply-text maxlength="3000" placeholder="Write your reply..."></textarea><div class="mwm-diary__replies">'+(x.diary_replies||[]).map(y=>'<div class="mwm-diary__reply-item">'+esc(y.content)+'<br><small>— '+esc(y.nickname)+'</small></div>').join('')+'</div></div></article>').join('');f.querySelectorAll('[data-reply-button]').forEach(b=>b.onclick=()=>reply(b.closest('[data-entry]').dataset.id,b))}catch(e){f.innerHTML='<div class="mwm-diary__empty">We couldn’t load the diary right now. Try again in a moment.</div>'}}r.querySelector('[data-refresh]').onclick=load;load()})();

  } catch(e) { console.error(e); }
})();
})();
